var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"action-button-component bg-color",class:_vm.color,on:{"click":function($event){return _vm.actionClick(_vm.name)}}},[_c('i',{staticClass:"fa",class:[ _vm.icon ]}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }